import apiService from './apiService';

const ADMIN_PREFIX = '/admin/flash-sale';
const PUBLIC_PREFIX = '/flash-sale';

export const flashSaleService = {
  // --- ADMIN APIs ---
  getCampaigns: () => apiService.get(`${ADMIN_PREFIX}/campaigns`),
  
  createCampaign: (data) => apiService.post(`${ADMIN_PREFIX}/campaigns`, data),
  
  updateCampaign: (id, data) => apiService.put(`${ADMIN_PREFIX}/campaigns/${id}`, data),
  
  deleteCampaign: (id) => apiService.delete(`${ADMIN_PREFIX}/campaigns/${id}`),

  getCampaignProducts: (campaignId) => apiService.get(`${ADMIN_PREFIX}/campaigns/${campaignId}/products`),

  addProductToCampaign: (campaignId, productData) => 
    apiService.post(`${ADMIN_PREFIX}/campaigns/${campaignId}/products`, productData),

  updateProductInCampaign: (flashSaleProductId, productData) => 
    apiService.put(`/admin/flash-sale/products/${flashSaleProductId}`, productData),

  removeProductFromCampaign: (flashSaleProductId) => 
    apiService.delete(`/admin/flash-sale/products/${flashSaleProductId}`),

  // Lấy danh sách sản phẩm gốc từ kho
  getAllProducts: () => apiService.get('home/products/all'),
};